import { render } from "./declaracion_origen_fondos.vue?vue&type=template&id=745b0671"
import script from "./declaracion_origen_fondos.vue?vue&type=script&lang=js"
export * from "./declaracion_origen_fondos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__